export enum frontPicEnum {
  default = "1",
  custom = "2",
  fullScreen = "3",
}
